<template>
  <el-col :span="props.spanColumn">
    <div class="label">
      {{ props.label }}
      <el-tooltip
        v-if="settings && settings.tooltip"
        :content="settings.tooltip"
        :trigger="['hover', 'click']"
        placement="top"
        popper-class="custom-switch-tooltip"
      >
        <IconInformationOutline class="info-icon" />
      </el-tooltip>
    </div>
    <el-switch
      v-model="value"
      :class="settings && settings.inputClass"
      size="default"
      :disabled="settings && settings.disabled"
      :active-text="settings && settings.activeText"
      :inactive-text="settings && settings.inactiveText"
    ></el-switch>
  </el-col>
</template>

<script setup>
import { computed } from 'vue';
import IconInformationOutline from '~icons/mdi/information-outline';
//props
const props = defineProps({
  spanColumn: Number,
  label: String,
  settings: {
    inputClass: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    activeText: String,
    inactiveText: String,
    /** Texto del tooltip; si se pasa, muestra el ícono de información junto al label. */
    tooltip: String,
  },
  modelValue: {
    type: [String, Number, Boolean, Object],
  },
});
const emit = defineEmits(['update:modelValue']);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>

<style scoped>
.label {
  font-weight: 700;
  color: #111;
}

.info-icon {
  margin-left: 4px;
  vertical-align: middle;
  color: #909399;
  cursor: pointer;
}
</style>

<style>
/* El contenido del tooltip se teletransporta fuera del componente (Element Plus lo
   monta en <body>), así que no lo alcanza el <style scoped> de arriba. */
.custom-switch-tooltip {
  max-width: 260px;
  font-size: 12px;
  line-height: 1.5;
  white-space: normal;
}
</style>
